// src/services/flightService.ts
import axios from "axios";

const API_URL = "http://localhost:5000/api/flightbookings";

export const getFlightsBooking = () => axios.get(API_URL);
export const createFlightBooking = (flight: any) => axios.post(API_URL, flight);
export const updateFlightBooking = (id: string, flight: any) =>
  axios.put(`${API_URL}/${id}`, flight);
export const deleteFlightBooking = (id: string) =>
  axios.delete(`${API_URL}/${id}`);
